import type { CustomAttributeData } from '@risksmart-app/domain/src/types/common.types';
import type {
  InputMaybe,
  InsertObligationAssessmentResultMutation,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import { InsertObligationAssessmentResultDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export interface InsertObligationAssessmentResultInput {
  Rating: number;
  ObligationIds: string[];
  AssessmentId?: InputMaybe<string>;
  TestDate?: InputMaybe<string>;
  Rationale?: InputMaybe<string>;
  CustomAttributeData?: InputMaybe<CustomAttributeData>;
}

export const useInsertObligationAssessmentResult = createMutationHook({
  name: 'insertObligationAssessmentResult',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.obligationAssessmentResult.insert.mutationOptions({
      onSuccess,
    }),
  mapInput: (input: InsertObligationAssessmentResultInput) => input,
  // Invalidation parity with the legacy Apollo evictFields:
  // obligation_assessment_result (+ aggregate) and assessment.
  invalidate: (trpc) => [
    trpc.frontend.obligationAssessmentResult.pathKey(),
    trpc.frontend.assessment.pathKey(),
  ],
  mapResponse: (result: {
    Ids: string[];
  }): InsertObligationAssessmentResultMutation => ({
    insertChildObligationAssessmentResult: {
      __typename: 'InsertChildObligationAssessmentResultOutput',
      Ids: result.Ids,
    },
  }),
  graphqlDocument: InsertObligationAssessmentResultDocument,
  graphqlVariables: (input: InsertObligationAssessmentResultInput) => ({
    ...input,
  }),
  evictFields: [
    'obligation_assessment_result',
    'assessment',
    'obligation_assessment_result_aggregate',
  ],
});
